<div *ngIf="formReady">
    <formio [formKey]="formKey" [submission]="submission"></formio>
</div>